import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import { extractDecimalPrecisionFromUnitDenominator } from '@dealstack/shared/lib/format/number.ts';
import { formatNumber } from '@dealstack/shared/lib/format/number';
import {
	GetTransactionRes,
	TransactionFilterDto,
	TransactionWithSecurityUnitDenominatorTct,
} from '@dealstack/shared/lib/generated';
import { TransactionTableFilter } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Transactions/types.ts';
import {
	browserDateToEndOfDayUTC,
	browserDateToMidnightUTC,
} from '@dealstack/frontend/shared/utils/utc.ts';

export const NONE_SPECIFIED_VALUE = 'NONE_SPECIFIED';

export const initialSorting: { id: string; desc: boolean }[] = [];

export const formatTransactionUnits = (
	transaction: GetTransactionRes | TransactionWithSecurityUnitDenominatorTct | null
) => {
	if (!transaction) {
		return LONG_DASH;
	}

	let precision = 0;

	if ('securityUnitDenominator' in transaction) {
		precision = extractDecimalPrecisionFromUnitDenominator(transaction.securityUnitDenominator);
	}

	return formatNumber({
		value: transaction.units ?? 0,
		lockPrecision: true,
		minPrecision: precision,
		maxPrecision: precision,
	});
};

/**
 * Converts the NONE_SPECIFIED_VALUE sentinel to null within the array,
 * preserving other selected values for OR filtering.
 */
const mapNoneSpecifiedToNull = (
	ids: Array<string | null> | null | undefined
): Array<string | null> | undefined => {
	if (!ids?.length) {
		return ids ?? undefined;
	}
	return ids.map((id) => (id === NONE_SPECIFIED_VALUE ? null : id));
};

export const mapTableFilterToDto = (filter?: TransactionTableFilter): TransactionFilterDto => {
	const { date, boughtForIds, soldForIds, buyerMipIds, sellerMipIds, ...rest } = filter ?? {};

	return {
		...rest,
		boughtForIds: mapNoneSpecifiedToNull(boughtForIds),
		soldForIds: mapNoneSpecifiedToNull(soldForIds),
		buyerMipIds: mapNoneSpecifiedToNull(buyerMipIds),
		sellerMipIds: mapNoneSpecifiedToNull(sellerMipIds),
		...(date
			? {
					dateFrom: date.from
						? browserDateToMidnightUTC(date.from) ?? undefined
						: undefined,
					dateTo: date.to ? browserDateToEndOfDayUTC(date.to) ?? undefined : undefined,
				}
			: {}),
	};
};
